export default "__VITE_ASSET__9ac3478b__"